"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortPages = exports.getPageOrder = exports.getDocumentFromTemplate = exports.getDefaultTemplate = exports.getDefaultJoyDocPage = exports.getDefaultJoyDocFile = exports.getDefaultJoyDoc = exports.getDefaultDocument = exports.getCleanedJoyDocPages = exports.getCleanedJoyDoc = exports.duplicateDocumentPage = exports.duplicate = exports["default"] = exports.cleanPageOrder = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _generateObjectId = _interopRequireDefault(require("./generateObjectId"));

var _validateObjectId = _interopRequireDefault(require("./validateObjectId"));

var _PageLayoutModes = _interopRequireDefault(require("./constants/PageLayoutModes"));

var _FieldPresentationModes = _interopRequireDefault(require("./constants/FieldPresentationModes"));

var _DocumentTypes = _interopRequireDefault(require("./constants/DocumentTypes"));

var _FieldTypes = _interopRequireDefault(require("./constants/FieldTypes"));

var _tableHelper = require("./tableHelper");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * Create default page
 *
 * @param {Object} defaults
 * @return {Object}
 */
var getDefaultJoyDocPage = function getDefaultJoyDocPage() {
  var defaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread({
    _id: (0, _generateObjectId["default"])(),
    name: 'New Page',
    width: 816,
    height: 1056,
    rowHeight: 8,
    cols: 8,
    fieldPositions: [],
    layout: _PageLayoutModes["default"].grid,
    presentation: _FieldPresentationModes["default"].normal,
    padding: 24
  }, defaults);
};
/**
 * Create default file
 *
 * @param {Object} defaults
 * @param {Object} pageDefaults
 * @return {Object}
 */


exports.getDefaultJoyDocPage = getDefaultJoyDocPage;

var getDefaultJoyDocFile = function getDefaultJoyDocFile() {
  var defaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var pageDefaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var page = getDefaultJoyDocPage(pageDefaults);
  return _objectSpread({
    _id: (0, _generateObjectId["default"])(),
    name: 'New File',
    pageOrder: [page._id],
    pages: [page],
    styles: {
      margin: 4
    }
  }, defaults);
};
/**
 * Create default document
 *
 * @param {Object} defaults
 * @param {Object} pageDefaults
 * @return {Object}
 */


exports.getDefaultJoyDocFile = getDefaultJoyDocFile;

var getDefaultJoyDoc = function getDefaultJoyDoc() {
  var defaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var fileDefaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var pageDefaults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var id = (0, _generateObjectId["default"])();
  return _objectSpread({
    _id: id,
    identifier: "doc_".concat(id),
    name: 'New Doc',
    files: [getDefaultJoyDocFile(fileDefaults, pageDefaults)],
    fields: []
  }, defaults);
};
/**
 * Get Clean JoyDoc Format
 *
 * Solves Issue: https://app.zenhub.com/workspaces/joyfill-platform-5f07262b507391001f56c7f9/issues/gh/zionlabs/issues/2105
 *
 * This selector ensures a couple of things:
 * 1. Valid file inside the document.
 * 2. Valid page inside document file.
 * 3. All _id's (page, file, page, fieldPosition, field) are in a valid format
 * 4. Row order of table field is free from duplicate/deletedRow Ids
 *
 * @param {Object} doc
 * @returns {Object}
 */


exports.getDefaultJoyDoc = getDefaultJoyDoc;

var getCleanedJoyDoc = function getCleanedJoyDoc(doc) {
  if (!doc) return getDefaultJoyDoc();

  var nextDoc = _objectSpread({}, doc);
  /**
   * Step 1.1: Replace doc._id if it is not valid
   */


  if (nextDoc._id && !(0, _validateObjectId["default"])(nextDoc._id)) nextDoc._id = (0, _generateObjectId["default"])();

  if (nextDoc.files && nextDoc.files.length > 0) {
    nextDoc.files = nextDoc.files.map(function (file) {
      var _nextFile$views;

      var nextFile = _objectSpread({}, file);
      /**
      * Step 1.2: Replace files[x]._id if it is not valid
      */


      if (nextFile._id && !(0, _validateObjectId["default"])(nextFile._id)) nextFile._id = (0, _generateObjectId["default"])();
      /**
      * Step 1.3: Replace page ids and field ids if they are not valid
      */

      nextFile.pages = getCleanedJoyDocPages(nextFile.pages);
      nextFile.pageOrder = cleanPageOrder(getPageOrder(nextFile.pageOrder, nextFile.pages), nextFile.pages);
      /**
      * Step 1.4: Replace view page ids and field ids if they are not valid
      */

      if ((nextFile === null || nextFile === void 0 ? void 0 : (_nextFile$views = nextFile.views) === null || _nextFile$views === void 0 ? void 0 : _nextFile$views.length) > 0) {
        nextFile.views = nextFile.views.map(function (view) {
          var nextView = _objectSpread({}, view);

          nextView.pages = getCleanedJoyDocPages(nextView.pages);
          nextView.pageOrder = cleanPageOrder(getPageOrder(nextView.pageOrder, nextView.pages), nextView.pages);
          return nextView;
        });
      }

      return nextFile;
    });
  } else {
    nextDoc.files = [getDefaultJoyDocFile()];
  }
  /**
   * Logic below is used to clean the table field rowOrder by removing the
   * deletedRowIds / duplicateRowIds from the rowOrder.
   **/


  if (nextDoc.fields && nextDoc.fields.length > 0) {
    nextDoc.fields = nextDoc.fields.map(function (field) {
      var nextField = _objectSpread({}, field);

      if (field.type === _FieldTypes["default"].table) {
        var cleanedRoworder = (0, _tableHelper.getCleanedRowOrder)(field.rowOrder, field.value);
        nextField.rowOrder = cleanedRoworder;
      }

      return nextField;
    });
  }

  return nextDoc;
};
/**
 * Get Cleaned JoyDoc Pages
 *
 * Solves Issue: https://app.zenhub.com/workspaces/joyfill-platform-5f07262b507391001f56c7f9/issues/gh/zionlabs/issues/2105
 *
 * This selector ensures a couple of things:
 * 1. Valid page inside document file.pages array.
 * 2. All id's in pages and fieldPositions are valid format
 *
 * @param {Object} doc
 * @returns {Object}
 */


exports.getCleanedJoyDoc = getCleanedJoyDoc;

var getCleanedJoyDocPages = function getCleanedJoyDocPages(pages) {
  if ((pages === null || pages === void 0 ? void 0 : pages.length) > 0) {
    return pages.map(function (page) {
      /**
      * Step 1: Replace pages[x]._id if it is not valid
      */
      var nextPage = _objectSpread({}, page);

      if (nextPage._id && !(0, _validateObjectId["default"])(nextPage._id)) nextPage._id = (0, _generateObjectId["default"])();

      if (nextPage.fieldPositions && nextPage.fieldPositions.length > 0) {
        nextPage.fieldPositions = nextPage.fieldPositions.map(function (fieldPosition) {
          /**
          * Step 1.2: Replace fieldPosition _id and field reference if they are not valid
          */
          var nextFieldPosition = _objectSpread({}, fieldPosition);

          if (nextFieldPosition._id && !(0, _validateObjectId["default"])(nextFieldPosition._id)) nextFieldPosition._id = (0, _generateObjectId["default"])();
          if (nextFieldPosition.field && !(0, _validateObjectId["default"])(nextFieldPosition.field)) nextFieldPosition.field = (0, _generateObjectId["default"])();
          return nextFieldPosition;
        });
      } else {
        nextPage.fieldPositions = [];
      }

      return nextPage;
    });
  } else {
    return [getDefaultJoyDocPage()];
  }
};
/**
 * Get page order
 *
 * @param {Array} pages
 * @param {Array} pageOrder
 * @return {Array}
 */


exports.getCleanedJoyDocPages = getCleanedJoyDocPages;

var getPageOrder = function getPageOrder(pageOrder, pages) {
  return pageOrder || pages.map(function (page) {
    return page._id;
  });
};
/**
  *
  * Clean pageOrder
  *
  * 1. Remove any pageIds associated with a missing page.
  * 2. Remove any underfined or invalid pageIds
  * 3. Remove any duplicate pageIds
  *
  * @param {Array} pageOrder //[string, string, ...]
  * @param {Array} pages //[object, object, ...]
  * @returns {Array}
*/


exports.getPageOrder = getPageOrder;

var cleanPageOrder = function cleanPageOrder(pageOrder, pages) {
  var pageLookup = {};
  pages.forEach(function (page) {
    return pageLookup[page._id] = page && !page.deleted;
  });
  return pageOrder.filter(function (pageId, index) {
    return pageLookup[pageId] && pageId && pageOrder.indexOf(pageId) === index;
  });
};
/**
 * Sort pages based on pageOrder
 */


exports.cleanPageOrder = cleanPageOrder;

var sortPages = function sortPages(pages, pageOrder) {
  if (!pageOrder) return pages;
  var pageLookup = {};
  pages.forEach(function (page) {
    pageLookup[page._id] = page;
  });
  var sortedPages = [];
  pageOrder.forEach(function (pageId) {
    if (pageLookup[pageId]) sortedPages.push(pageLookup[pageId]);
  });
  return sortedPages;
};
/**
 * Get a properly formatted Document JoyDoc
 *
 * @returns {Object}
 */


exports.sortPages = sortPages;

var getDefaultDocument = function getDefaultDocument() {
  var type = _DocumentTypes["default"].document;

  var _id = (0, _generateObjectId["default"])();

  var identifier = "doc_".concat(_id);
  var name = 'New Doc';
  return getDefaultJoyDoc({
    type: type,
    _id: _id,
    identifier: identifier,
    name: name
  });
};
/**
 * Get a properly formatted Template JoyDoc
 *
 * @returns {Object}
 */


exports.getDefaultDocument = getDefaultDocument;

var getDefaultTemplate = function getDefaultTemplate() {
  var type = _DocumentTypes["default"].template;

  var _id = (0, _generateObjectId["default"])();

  var identifier = "template_".concat(_id);
  var name = 'New Template';
  return getDefaultJoyDoc({
    type: type,
    _id: _id,
    identifier: identifier,
    name: name
  });
};
/**
 * Get a properly formatted duplicate of a Template or Document
 *
 * @returns {Object}
 */


exports.getDefaultTemplate = getDefaultTemplate;

var duplicate = function duplicate(original, defaults) {
  //Remove all references to original template object
  var origin = JSON.parse(JSON.stringify(original));

  var _id = (0, _generateObjectId["default"])();

  var identifier = origin.type === _DocumentTypes["default"].template ? "template_".concat(_id) : "doc_".concat(_id);
  return _objectSpread(_objectSpread({}, origin), {}, {
    _id: _id,
    identifier: identifier,
    createdOn: new Date().getTime(),
    source: origin.identifier
  }, defaults);
};
/**
 * Get a properly formatted Document JoyDoc from Template JoyDoc
 *
 * @param {Object} template
 * @returns {Object}
 */


exports.duplicate = duplicate;

var getDocumentFromTemplate = function getDocumentFromTemplate(template) {
  var _id = (0, _generateObjectId["default"])();

  var identifier = "doc_".concat(_id); //Remove all references to original template object

  var temp = JSON.parse(JSON.stringify(template));
  return {
    _id: _id,
    identifier: identifier,
    type: _DocumentTypes["default"].document,
    name: temp.name,
    template: temp.identifier,
    source: temp.identifier,
    files: temp.files,
    fields: temp.fields
  };
};
/**
 * Handle Page Duplication for JoyDoc
 *
 * @param {Object} doc //Full JoyDoc Payload for Template or Document
 * @param {String} fileId //File ID that contains the page we are duplicating
 * @param {String} pageId
 * @param {Object} pageDefaults
 * @returns {Object}
 */


exports.getDocumentFromTemplate = getDocumentFromTemplate;

var duplicateDocumentPage = function duplicateDocumentPage(doc, fileId, pageId) {
  var _nextDoc$fields;

  var pageDefaults = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var changelogInfo = {
    primaryPages: {
      targetIndex: 0,
      page: null
    },
    viewPages: [],
    fields: []
  };
  var nextDoc = JSON.parse(JSON.stringify(doc));
  var fileIndex = nextDoc.files.findIndex(function (file) {
    return file._id === fileId;
  });
  var newPageId = (0, _generateObjectId["default"])();
  var fieldLookup = {};
  (_nextDoc$fields = nextDoc.fields) === null || _nextDoc$fields === void 0 ? void 0 : _nextDoc$fields.forEach(function (field) {
    if (field.file === fileId) fieldLookup[field._id] = field;
  });
  /**
   * Step 1: Duplicate fields associated with target page
   */

  var fieldIdsToDuplicate = []; //Step 1.1 Get all field Ids from primary page

  var targetPageIndex = nextDoc.files[fileIndex].pages.findIndex(function (page) {
    return page._id === pageId;
  });
  if (targetPageIndex !== -1) nextDoc.files[fileIndex].pages[targetPageIndex].fieldPositions.forEach(function (fieldPosition) {
    return fieldIdsToDuplicate.push(fieldPosition.field);
  }); //Step 1.2 Get all field Ids from view page

  if (nextDoc.files[fileIndex].views && nextDoc.files[fileIndex].views.length > 0) {
    nextDoc.files[fileIndex].views.forEach(function (view) {
      var viewPageIndex = view.pages.findIndex(function (page) {
        return page._id === pageId;
      });

      if (viewPageIndex !== -1) {
        view.pages[viewPageIndex].fieldPositions.forEach(function (fieldPosition) {
          if (fieldIdsToDuplicate.indexOf(fieldPosition.field) === -1) fieldIdsToDuplicate.push(fieldPosition.field);
        });
      }
    });
  }

  var newFieldsLookupByOldId = {};
  var duplicatedFields = [];
  fieldIdsToDuplicate.forEach(function (fieldId) {
    /**
     * Why do we check if a new field has already been created?
     *
     * That is because multiple field positions can be associated with the same
     * field. If a field has already been created by a previous field position
     * that is linked to the same field as the current target then do not create
     * again.
     */
    if (newFieldsLookupByOldId[fieldId]) return;
    var field = fieldLookup[fieldId];

    var duplicateField = _objectSpread(_objectSpread({}, field), {}, {
      _id: (0, _generateObjectId["default"])()
    });

    duplicatedFields.push(duplicateField);
    /**
     * Add to lookup so it can be used with other associated field positions
     */

    newFieldsLookupByOldId[field._id] = duplicateField;
  });
  /**
   * Step 2: Update newly duplicated fields logic properties
   *
   * This step can only be done after all fields have been properly duplicated.
   *
   * We only need to update logic conditions that referenced the target page
   * that we are duplicating. We do this by checking the logic.condition[x].page
   * property of the condition.
   */

  duplicatedFields = duplicatedFields.map(function (duplicatedField) {
    if (!duplicatedField.logic || !duplicatedField.logic.conditions || duplicatedField.logic.conditions.length < 1) return duplicatedField;

    var nextField = _objectSpread(_objectSpread({}, duplicatedField), {}, {
      logic: _objectSpread({}, duplicatedField.logic)
    });

    nextField.logic.conditions = nextField.logic.conditions.map(function (condition) {
      /**
       * 1. Only update conditions associated with the current page being duplicated.
       * 2. Only update conditions associated with a field that was duplicated.
       */
      if (condition.page === pageId && newFieldsLookupByOldId[condition.field]) {
        return _objectSpread(_objectSpread({}, condition), {}, {
          page: newPageId,
          field: newFieldsLookupByOldId[condition.field]._id
        });
      } else {
        return condition;
      }
    });
    return nextField;
  });
  /**
   * Step 3: Add newly duplicated fields changelogs and update doucment
   */

  duplicatedFields.forEach(function (duplicateField) {
    changelogInfo.fields.push(duplicateField);
    nextDoc.fields.push(duplicateField);
  });
  /**
   * Step 4: Update Primary View Page Order
   *
   * IMPORTANT NOTE: Page order update must go before page object creation.
   */

  var pageOrder = getPageOrder(nextDoc.files[fileIndex].pageOrder, nextDoc.files[fileIndex].pages);
  var primaryPageOrderIndex = pageOrder.findIndex(function (id) {
    return id === pageId;
  });
  var primaryPageOrderTargetIndex = primaryPageOrderIndex + 1;
  nextDoc.files[fileIndex].pageOrder = pageOrder;
  nextDoc.files[fileIndex].pageOrder.splice(primaryPageOrderTargetIndex, 0, newPageId);
  /**
   * Step 5: Generate Primary View Page
   */

  var primaryPageIndex = nextDoc.files[fileIndex].pages.findIndex(function (page) {
    return page._id === pageId;
  });
  var newPrimaryPage = primaryPageIndex === -1 ? null : _objectSpread(_objectSpread({}, nextDoc.files[fileIndex].pages[primaryPageIndex]), {}, {
    _id: newPageId,
    fieldPositions: []
  }, pageDefaults);
  nextDoc.files[fileIndex].pages[primaryPageIndex].fieldPositions.forEach(function (fieldPosition) {
    var newField = newFieldsLookupByOldId[fieldPosition.field];
    newPrimaryPage.fieldPositions.push(_objectSpread(_objectSpread({}, fieldPosition), {}, {
      field: newField._id
    }));
  });
  nextDoc.files[fileIndex].pages.splice(primaryPageIndex + 1, 0, newPrimaryPage);
  /**
   * Step 6: Update Primary Page Changelog
   */

  changelogInfo.primaryPages.targetIndex = primaryPageOrderTargetIndex;
  changelogInfo.primaryPages.page = newPrimaryPage;
  /**
   * Step 7: Update Views
   */

  if (nextDoc.files[fileIndex].views && nextDoc.files[fileIndex].views.length > 0) {
    nextDoc.files[fileIndex].views = nextDoc.files[fileIndex].views.map(function (view) {
      var nextView = _objectSpread({}, view);

      var viewPageIndex = nextView.pages.findIndex(function (page) {
        return page._id === pageId;
      });
      if (viewPageIndex === -1) return view;
      /**
       * Step 7.1 Update View Page Order.
       *
       * IMPORTANT NOTE: Page order update must go before page object creation.
       */

      var nextViewPageOrder = getPageOrder(nextView.pageOrder, nextView.pages);
      var nextViewPageOrderIndex = nextViewPageOrder.findIndex(function (id) {
        return id === pageId;
      });
      var nextViewTargetPageOrderIndex = nextViewPageOrderIndex + 1;
      nextView.pageOrder = nextViewPageOrder;
      nextView.pageOrder.splice(nextViewTargetPageOrderIndex, 0, newPageId);
      /**
       * Step 7.2 Update View Pages
       */

      var newViewPage = _objectSpread(_objectSpread({}, nextView.pages[viewPageIndex]), {}, {
        _id: newPageId,
        fieldPositions: []
      }, pageDefaults);

      nextView.pages[viewPageIndex].fieldPositions.forEach(function (fieldPosition) {
        var newField = newFieldsLookupByOldId[fieldPosition.field];
        newViewPage.fieldPositions.push(_objectSpread(_objectSpread({}, fieldPosition), {}, {
          field: newField._id
        }));
      });
      nextView.pages.splice(viewPageIndex + 1, 0, newViewPage);
      /**
       * Step 7.3 Add View Page Changelog Info
       */

      changelogInfo.viewPages.push({
        viewId: view._id,
        view: view.type,
        targetIndex: nextViewTargetPageOrderIndex,
        page: newViewPage
      });
      return nextView;
    });
  }

  return {
    changelogInfo: changelogInfo,
    doc: nextDoc
  };
};

exports.duplicateDocumentPage = duplicateDocumentPage;
var _default = {
  getDefaultJoyDocPage: getDefaultJoyDocPage,
  getDefaultJoyDocFile: getDefaultJoyDocFile,
  getDefaultJoyDoc: getDefaultJoyDoc,
  getCleanedJoyDoc: getCleanedJoyDoc,
  getCleanedJoyDocPages: getCleanedJoyDocPages,
  getDefaultDocument: getDefaultDocument,
  getDefaultTemplate: getDefaultTemplate,
  getDocumentFromTemplate: getDocumentFromTemplate,
  duplicate: duplicate,
  duplicateDocumentPage: duplicateDocumentPage,
  getPageOrder: getPageOrder,
  sortPages: sortPages
};
exports["default"] = _default;